module.exports = __webpack_public_path__ + "static/media/foosball.0b88776b.webp";